import { Component, OnInit, Output, Inject } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpParams } from "@angular/common/http";
import { RegistrationInterface } from '../registration-interface';
import { Router } from '@angular/router';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {

  http: HttpClient;
  baseURL = '';
  regShow: boolean = true;
  confPassValid: boolean = true;
  errorReg: boolean = false;
  errorPass: boolean = false;
  errorConfPass: boolean = false;
  invalidReg: boolean = false;
  regSuccess: boolean = false;
  data: Object;
  myRecaptcha: any[];
  captchaError: boolean = false;
  captchaValidated: boolean = false;
 


  constructor(@Inject(HttpClient) http: HttpClient, @Inject('BASE_URL') baseUrl: string, @Inject(Router) _router: Router) {
    this.http = http;
    this.baseURL = baseUrl;
    this.router = _router;
  }
  router: Router;
  navigation: any;

  registrationInfo: RegistrationInterface = {
    userInviteId: '',
    password: '',
    confirmPassword: ''
  }

  @Output() showReg: EventEmitter<boolean> = new EventEmitter();


  BackToLogin() {
    this.router.navigate(['/', 'login']);
  }

  Register(registrationInfo) {

    let inviteUniqueId = registrationInfo.userInviteId;
    let password = registrationInfo.password;
    let confirmPassword = registrationInfo.confirmPassword;
   
    let cont = true;
    this.errorReg = false;
    this.errorPass = false;
    this.errorConfPass = false;


    if (inviteUniqueId == '') {
      cont = false;
      this.errorReg = true;
    }

    if (password == '') {
      cont = false;
      this.errorPass = true;
    }

    if (confirmPassword == '') {
      cont = false;
      this.errorConfPass = true;
    }

    if (cont == true && this.captchaValidated == true) {
      this.captchaError = false;

      let params = new HttpParams();
      params = params.append('InviteUniqueId', inviteUniqueId);
      params = params.append('Password', password);


      this.http.get(this.baseURL + 'api/Register/Register', { params: params }).subscribe(data => {
        this.data = data;
        console.log(data);

        if (data != false) {
          this.regSuccess = true;
        } else {
          this.invalidReg = true;
        }
      });
    }
    else {
      if (this.captchaValidated == false) {
        this.captchaError = true;
      }
    }
  }

  CheckPassConfirm() {
    let password = (document.getElementById("password") as HTMLInputElement).value;
    let confirmPassword = (document.getElementById("confirmpassword") as HTMLInputElement).value;

    if (password == confirmPassword) {
      this.confPassValid = true;
    } else {
      this.confPassValid = false;
    }
  }

  ngOnInit() {
  }

  resolved(captchaResponse: any[]) {
    this.myRecaptcha = captchaResponse;


    let params = new HttpParams();
    params = params.append('response', this.myRecaptcha.toString());


    this.http.get('api/Captcha/getCaptchaResponse', { params: params }).subscribe(data => {

      if (data) {
        this.captchaValidated = true;
        this.captchaError = false;

      } else {
        //don't allow password reset
        this.captchaValidated = false;
        this.captchaError = true;
      }

    });
  }

}
